import script from "./MultiDocsBlock20321.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiDocsBlock20321.vue?vue&type=script&setup=true&lang=ts"

import "./MultiDocsBlock20321.vue?vue&type=style&index=0&id=8694f154&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8694f154"]])

export default __exports__